import { frontendURL } from '../../../../helper/URLHelper';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

const ReportsWrapper = () => import('./components/ReportsWrapper.vue');
const ConversationsDashboard = () => import('./ConversationsDashboard.vue');
const LifecycleReport = () => import('./LifecycleReport.vue');
const AdsReport = () => import('./AdsReport.vue');
const CallsReport = () => import('./CallsReport.vue');
const ConversationPerformanceReport = () =>
  import('./ConversationPerformanceReport.vue');
const ActivityReport = () => import('./ActivityReport.vue');
const PeopleReport = () => import('./PeopleReport.vue');
const BroadcastsReport = () => import('./BroadcastsReport.vue');

const LabelReportsIndex = () => import('./LabelReportsIndex.vue');

const LabelReportsShow = () => import('./LabelReportsShow.vue');

const LabelReports = () => import('./LabelReports.vue');

const CsatResponses = () => import('./CsatResponses.vue');
const BotReports = () => import('./BotReports.vue');
const SLAReports = () => import('./SLAReports.vue');

const meta = {
  featureFlag: FEATURE_FLAGS.REPORTS,
  permissions: ['administrator', 'report_manage'],
};

const redirectTo = (name, filterKey) => to => ({
  name,
  params: { accountId: to.params.accountId },
  ...(filterKey && to.params.id
    ? { query: { [filterKey]: to.params.id } }
    : {}),
});

const oldReportRoutes = [
  {
    path: 'agent',
    name: 'agent_reports',
    meta,
    redirect: redirectTo('users_reports'),
  },
  {
    path: 'inboxes',
    name: 'inbox_reports',
    meta,
    redirect: redirectTo('conversation_reports'),
  },
  {
    path: 'label',
    name: 'label_reports',
    meta,
    component: LabelReports,
  },
  {
    path: 'teams',
    name: 'team_reports',
    meta,
    redirect: redirectTo('leaderboard_reports'),
  },
];

const revisedReportRoutes = [
  {
    path: 'agents_overview',
    name: 'agent_reports_index',
    meta,
    redirect: redirectTo('users_reports'),
  },
  {
    path: 'agents/:id',
    name: 'agent_reports_show',
    meta,
    redirect: redirectTo('users_reports', 'agent_id'),
  },

  {
    path: 'inboxes_overview',
    name: 'inbox_reports_index',
    meta,
    redirect: redirectTo('conversation_reports'),
  },
  {
    path: 'inboxes/:id',
    name: 'inbox_reports_show',
    meta,
    redirect: redirectTo('conversation_reports', 'inbox_id'),
  },
  {
    path: 'teams_overview',
    name: 'team_reports_index',
    meta,
    redirect: redirectTo('leaderboard_reports'),
  },
  {
    path: 'teams/:id',
    name: 'team_reports_show',
    meta,
    redirect: redirectTo('conversation_reports', 'team_id'),
  },
  {
    path: 'labels_overview',
    name: 'label_reports_index',
    meta,
    component: LabelReportsIndex,
  },
  {
    path: 'labels/:id',
    name: 'label_reports_show',
    meta,
    component: LabelReportsShow,
  },
];

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/reports'),
      component: ReportsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'lifecycle_reports', params: to.params };
          },
        },
        {
          path: 'overview',
          name: 'account_overview_reports',
          meta,
          redirect: redirectTo('lifecycle_reports'),
        },
        {
          path: 'lifecycle',
          name: 'lifecycle_reports',
          meta,
          component: LifecycleReport,
        },
        {
          path: 'ads',
          name: 'ads_reports',
          meta,
          component: AdsReport,
        },
        {
          path: 'calls',
          name: 'calls_reports',
          meta,
          component: CallsReport,
        },
        {
          path: 'conversation',
          name: 'conversation_reports',
          meta,
          component: ConversationsDashboard,
        },
        {
          path: 'responses',
          name: 'responses_reports',
          meta,
          component: ConversationPerformanceReport,
          props: { reportType: 'responses' },
        },
        {
          path: 'resolutions',
          name: 'resolutions_reports',
          meta,
          component: ConversationPerformanceReport,
          props: { reportType: 'resolutions' },
        },
        {
          path: 'messages',
          name: 'messages_reports',
          meta,
          component: ActivityReport,
          props: { reportType: 'messages' },
        },
        {
          path: 'contacts',
          name: 'contacts_reports',
          meta,
          component: ActivityReport,
          props: { reportType: 'contacts' },
        },
        {
          path: 'assignments',
          name: 'assignments_reports',
          meta,
          component: ActivityReport,
          props: { reportType: 'assignments' },
        },
        {
          path: 'leaderboard',
          name: 'leaderboard_reports',
          meta,
          component: PeopleReport,
          props: { reportType: 'leaderboard' },
        },
        {
          path: 'users',
          name: 'users_reports',
          meta,
          component: PeopleReport,
          props: { reportType: 'users' },
        },
        {
          path: 'broadcasts',
          name: 'broadcasts_reports',
          meta,
          component: BroadcastsReport,
        },
        ...oldReportRoutes,
        ...revisedReportRoutes,
        {
          path: 'sla',
          name: 'sla_reports',
          meta,
          component: SLAReports,
        },
        {
          path: 'csat',
          name: 'csat_reports',
          meta,
          component: CsatResponses,
        },
        {
          path: 'bot',
          name: 'bot_reports',
          meta,
          component: BotReports,
        },
      ],
    },
  ],
};
